(() => {
// Link timelines to scroll position
function $1aa2e0393d0f1beb$var$createScrollTrigger(triggerElement, elements, start, end, stagger, delay, withScroll) {
    const trigger = {
        trigger: triggerElement,
        scrub: true,
        start: start,
        fastScrollEnd: 500,
        preventOverlaps: "scroll-text"
    };
    if (!withScroll) {
        trigger.onEnter = ()=>{
            gsap.to(elements, {
                yPercent: 0,
                stagger: stagger,
                ease: "power4.out",
                delay: Number(delay)
            });
        };
        return gsap.timeline({
            scrollTrigger: trigger
        });
    } else {
        trigger.end = end;
        return gsap.timeline({
            scrollTrigger: trigger
        }).to(words, {
            yPercent: 0,
            stagger: stagger,
            ease: "none"
        });
    }
}
function $1aa2e0393d0f1beb$export$1601281ad392a6d8() {
    // Split all words on the brand core section
    const textEls = document.querySelectorAll("[stagger-text]");
    textEls.forEach((el)=>{
        el.classList.add("init");
        const startVal = el.dataset.startPos || "center bottom", endVal = el.dataset.endPos || "bottom center", stagger = el.dataset.stagger || 0.05, delay = el.dataset.delay || 0, withScrollTrigger = el.dataset.withScroll || false;
        if (el.classList.contains("w-richtext")) {
            const staggerTextEls = SplitText.create(el.querySelectorAll("p, li, h2, h3"), {
                type: "lines",
                mask: "lines",
                autoSplit: true,
                onSplit: (self)=>{
                    gsap.set(self.lines, {
                        yPercent: 102
                    });
                    return $1aa2e0393d0f1beb$var$createScrollTrigger(el, self.lines, startVal, endVal, stagger, delay, withScrollTrigger);
                }
            });
        } else {
            const staggerTextEls = SplitText.create(el, {
                type: "lines",
                mask: "lines",
                autoSplit: true,
                onSplit: (self)=>{
                    gsap.set(self.lines, {
                        yPercent: 100
                    });
                    return $1aa2e0393d0f1beb$var$createScrollTrigger(el, self.lines, startVal, endVal, stagger, delay, withScrollTrigger);
                }
            });
        }
    });
}


// Link timelines to scroll position
function $4013e65a83b1b778$var$createScrollList(triggerElement, elements, start, stagger, delay) {
    gsap.set(elements, {
        yPercent: 100,
        opacity: 0
    });
    gsap.timeline({
        scrollTrigger: {
            trigger: triggerElement,
            scrub: true,
            start: start,
            once: true,
            onEnter: ()=>{
                gsap.to(elements, {
                    yPercent: 0,
                    opacity: 1,
                    stagger: stagger,
                    ease: "power4.out",
                    delay: Number(delay)
                });
            }
        }
    });
}
function $4013e65a83b1b778$export$9b05384e3b3cbff1() {
    const list = document.querySelectorAll("[stagger-list]");
    if (!list) return;
    list.forEach((el)=>{
        const elements = el.querySelectorAll("[stagger-el]"), startVal = el.dataset.startPos || "top top", stagger = el.dataset.stagger || 0.05, delay = el.dataset.delay || 0;
        if (!elements) return;
        $4013e65a83b1b778$var$createScrollList(el, elements, startVal, stagger, delay);
    });
}


function $ce6a18b12420bce7$export$7fd17f34fe72f4b0() {
    const loading = document.querySelector(".loading");
    if (!loading) return;
    const outElements = loading.querySelectorAll(".loading_inner.out");
    const inElements = loading.querySelectorAll(".loading_inner.in");
    gsap.set(inElements, {
        yPercent: 0
    });
    gsap.set(outElements, {
        yPercent: 100
    });
    gsap.to(inElements, {
        yPercent: -100,
        duration: 1,
        stagger: 0.2,
        delay: 0.5,
        ease: "expo.out",
        immediateRender: true,
        onComplete: ()=>{
            loading.style.display = "none";
            gsap.set(inElements, {
                yPercent: 100
            });
        }
    });
    // Loading animation
    const links = document.querySelectorAll("a");
    links.forEach((l)=>{
        l.addEventListener("click", (e)=>{
            // e.preventDefault();
            const href = l.href;
            const url = new URL(href);
            if (window.location.origin === url.origin && window.location.pathname !== url.pathname && l.target !== "_blank") {
                e.preventDefault();
                loading.style.display = "block";
                gsap.to(outElements, {
                    yPercent: 0,
                    duration: 0.5,
                    stagger: 0.1,
                    ease: "expo.out",
                    immediateRender: true,
                    onComplete: ()=>{
                    // loading.style.display = "none";
                    }
                });
                setTimeout(()=>{
                    window.location.href = href;
                }, 500);
            }
        });
    });
}


function $8d7867a2083184cb$export$85958f7fefbafb9() {
    const videos = document.querySelectorAll("video.bg-video");
    if (!videos) return;
    videos.forEach((video)=>{
        const start = video.dataset.start || "top bottom";
        const pauseOutside = video.dataset.pauseOutside === "true";
        const rewind = video.dataset.rewind === "true";
        const loop = video.dataset.loop === "true";
        if (loop) video.loop = true;
        let settings = {
            trigger: video,
            start: start,
            onEnter: ()=>{
                video.play();
            }
        };
        if (pauseOutside) {
            settings.onLeave = ()=>{
                $8d7867a2083184cb$var$pauseOrRewind(video, rewind);
            };
            settings.onLeaveBack = ()=>{
                $8d7867a2083184cb$var$pauseOrRewind(video, rewind);
            };
            settings.onEnterBack = ()=>{
                video.play();
            };
        } else settings.once = true;
        ScrollTrigger.create(settings);
    });
}
function $8d7867a2083184cb$var$pauseOrRewind(video, rewind) {
    video.pause();
    if (rewind) video.currentTime = 0;
}


function $ee20a49b40292314$export$22ea07d0c2ddb570() {
    const menuItems = document.querySelectorAll(".menu-link[data-item]");
    if (!menuItems) return;
    const menuWrapper = document.querySelector(".menu-wrapper"), itemsWrapper = menuWrapper.querySelector(".menu-inner"), imgsWrapper = menuWrapper.querySelector(".menu-img-wrapper"), imgsItems = imgsWrapper.querySelectorAll(".menu-img-item"), menuTrigger = document.querySelector(".button.menu");
    gsap.set(itemsWrapper, {
        clipPath: "inset(0% 0% 100% 0%)"
    });
    gsap.set(imgsWrapper, {
        clipPath: "inset(100% 0% 0% 0%)"
    });
    gsap.set(menuItems, {
        opacity: 0,
        yPercent: 100
    });
    const tl = gsap.timeline({
        paused: true
    });
    const buttonTl = gsap.timeline({
        paused: true
    });
    buttonTl.fromTo(menuTrigger.querySelectorAll(".button-label-inner"), {
        xPercent: 0
    }, {
        xPercent: -100,
        ease: "power4.inOut",
        duration: 0.5
    });
    tl.to(menuWrapper, {
        display: "flex",
        duration: 0
    }).to(itemsWrapper, {
        clipPath: "inset(0% 0% 0% 0%)",
        ease: "power4.out",
        duration: 0.75
    }).to(imgsWrapper, {
        clipPath: "inset(0% 0% 0% 0%)",
        ease: "power4.out",
        duration: 0.75
    }, "-=.75").to(menuItems, {
        opacity: 1,
        yPercent: 0,
        stagger: 0.03,
        ease: "power4.out"
    }, "-=0.5");
    menuTrigger.addEventListener("click", ()=>{
        if (menuTrigger.classList.contains("active")) {
            tl.reverse();
            buttonTl.reverse();
            menuTrigger.classList.remove("active");
        } else {
            tl.play();
            buttonTl.play();
            menuTrigger.classList.add("active");
        }
    });
    // set first item on the list as the initial element. If a link is active, select that one instead.
    let currentItem = document.querySelector(".menu-link.w--current[data-item]");
    if (!currentItem) currentItem = document.querySelector(".menu-link[data-item]:first-child");
    let currentItemId = currentItem.dataset.item;
    gsap.set(`.menu-img-item[data-item="${currentItemId}"]`, {
        zIndex: 1
    });
    menuItems.forEach((item)=>{
        item.addEventListener("mouseover", ()=>{
            const itemId = item.dataset.item || null;
            if (!itemId || currentItemId === itemId) return;
            const imgWrapper = document.querySelector(`.menu-img-item[data-item="${itemId}"]`);
            if (!imgWrapper) return;
            const tl = gsap.timeline();
            tl.to(imgsItems, {
                zIndex: 0,
                duration: 0
            }).to(document.querySelector(`.menu-img-item[data-item="${currentItemId}"]`), {
                zIndex: 1,
                duration: 0
            }).to(imgWrapper, {
                zIndex: 2,
                duration: 0
            }).fromTo(imgWrapper, {
                clipPath: "inset(50%)"
            }, {
                clipPath: "inset(0%)",
                duration: 0.75,
                ease: "power4.out"
            }).fromTo(imgWrapper.querySelectorAll(".menu-img"), {
                scale: 1.2
            }, {
                scale: 1,
                duration: 0.75,
                // stagger: 0.1,
                ease: "power4.out"
            }, "-=.75");
            currentItemId = itemId;
        });
    });
}


function $d9d8e6151a123ccd$export$fc2ce4586759bfa0() {
    const imageMasks = document.querySelectorAll("[image-mask]");
    if (!imageMasks) return;
    const maskDirectionMap = {
        top: {
            start: "inset(0% 50% 100%)",
            end: "inset(0% 0% 0%)"
        },
        bottom: {
            start: "inset(100% 50% 0%)",
            end: "inset(0% 0% 0%)"
        },
        left: {
            start: "inset(50% 100% 50% 0%)",
            end: "inset(0% 0% 0% 0%)"
        },
        right: {
            start: "inset(50% 0% 50% 100%)",
            end: "inset(0% 0% 0% 0%)"
        },
        center: {
            start: "inset(50%)",
            end: "inset(0%)"
        }
    };
    imageMasks.forEach((el)=>{
        const type = el.getAttribute("image-mask");
        const mask = Object.keys(maskDirectionMap).includes(type) ? maskDirectionMap[type] : maskDirectionMap.center;
        $d9d8e6151a123ccd$var$setMask(el, mask);
    });
}
function $d9d8e6151a123ccd$var$setMask(el, mask) {
    const start = el.dataset.startPos || "center bottom";
    const loading = el.getAttribute("loading");
    el.style.opacity = 0;
    const imageMaskObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const el = entry.target;
                if (el.complete) animateImage(el);
                else el.addEventListener("load", ()=>animateImage(el));
                imageMaskObserver.unobserve(el);
            }
        });
    }, {
        threshold: 0.1
    });
    imageMaskObserver.observe(el);
    function animateImage(el) {
        el.style.opacity = 1;
        gsap.fromTo(el, {
            // opacity: 0,
            clipPath: mask.start
        }, {
            // opacity: 1,
            clipPath: mask.end,
            duration: 1,
            ease: "expo.out"
        });
    }
}


function $b140b9eb34f1ac44$export$4bc49541bd3cd0fc() {
    const forms = document.querySelectorAll("form");
    if (!forms) return;
    forms.forEach((form)=>{
        const formSubmitButton = form.querySelector(".button.is-submit");
        const submitButton = form.querySelector(".form_submit");
        const label = form.querySelector(".button-label");
        if (!formSubmitButton || !submitButton) return;
        // add event listener to the form submit button
        formSubmitButton.addEventListener("click", function(e) {
            e.preventDefault(); // prevent the default action
            // check if the form is valid
            if (form.checkValidity()) {
                // if valid, submit the form and change the button text
                submitButton.click();
                label.textContent = submitButton.getAttribute("data-wait");
            } else // if not valid, report validity (this will show the HTML5 validation messages)
            form.reportValidity();
        });
    });
}
function $b140b9eb34f1ac44$export$38297a6fd1fde1b1() {
    const formWrapper = document.querySelector(".contact-component");
    const formTriggers = document.querySelectorAll("[data-contact-trigger]");
    if (!formWrapper || !formTriggers) return;
    const formBody = formWrapper.querySelector(".contact-form_body"), formBackdrop = formWrapper.querySelector(".contact-form_backdrop"), closeBtn = formWrapper.querySelector(".button.is-modal-close");
    gsap.set(formWrapper, {
        display: "none"
    });
    gsap.set(formBody, {
        clipPath: "inset(50%)"
    });
    gsap.set(formBackdrop, {
        opacity: 0
    });
    gsap.set(closeBtn, {
        yPercent: -200
    });
    const tl = gsap.timeline({
        paused: true
    });
    tl.set(formWrapper, {
        display: "flex"
    }).to(formBackdrop, {
        opacity: 1,
        ease: "power4.out",
        duration: 0.75
    }, 0).to(formBody, {
        clipPath: "inset(0%)",
        ease: "power4.out",
        duration: 0.75
    }, 0.25).to(closeBtn, {
        yPercent: 0,
        ease: "power4.out",
        duration: .5
    }, .5);
    closeBtn.addEventListener("click", ()=>{
        tl.reverse();
    });
    formTriggers.forEach((trigger)=>{
        trigger.addEventListener("click", ()=>{
            tl.play();
        });
    });
}


window.addEventListener("beforeunload", ()=>{
    console.log("beforeunload");
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
window.addEventListener("popstate", ()=>{
    console.log("popstate");
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
document.addEventListener("pageshow", (event)=>{
    console.log("pageshow", event);
    // Check if the page was restored from the bfcache
    if (event.persisted) // Re-run your loading animation
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
document.addEventListener("DOMContentLoaded", function() {
    (0, $8d7867a2083184cb$export$85958f7fefbafb9)();
    (0, $4013e65a83b1b778$export$9b05384e3b3cbff1)();
    (0, $d9d8e6151a123ccd$export$fc2ce4586759bfa0)();
    (0, $ee20a49b40292314$export$22ea07d0c2ddb570)();
    setTimeout(()=>{
        (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
    }, 100);
});
document.fonts.ready.then(()=>{
    (0, $1aa2e0393d0f1beb$export$1601281ad392a6d8)();
    (0, $b140b9eb34f1ac44$export$4bc49541bd3cd0fc)();
    (0, $b140b9eb34f1ac44$export$38297a6fd1fde1b1)();
});

})();
//# sourceMappingURL=globals.js.map
